import { styled } from 'styled-components';

import { SummaryInformationRow } from 'src/components/summary-information-row';
import { colorNeutral, colorNeutral400, colorSecondary900 } from 'src/styles/colors';
import { focusCircle } from 'src/styles/mixins';
import { spacing2, spacing4 } from 'src/styles/spacing';

const RADIO_SIZE = '20px';

export const StyledContainer = styled.label`
  display: flex;

  &:not(:first-child) {
    margin-top: ${spacing4};
  }
`;

export const StyledInput = styled.input.attrs({ type: 'radio' })`
  appearance: none;
  background-color: ${colorNeutral};
  margin-top: 4px;
  height: ${RADIO_SIZE};
  width: ${RADIO_SIZE};
  border: 2px solid ${colorSecondary900};
  border-radius: 50%;
  display: grid;
  place-content: center;

  &:checked::before {
    content: '';
    height: ${RADIO_SIZE};
    width: ${RADIO_SIZE};
    border-radius: 50%;
    transform: scale(0.4);
    background-color: ${colorSecondary900};
  }

  &:hover {
    border-color: ${colorNeutral400};

    &:checked::before {
      background-color: ${colorNeutral400};
    }
  }

  ${focusCircle}
`;

export const StyledContent = styled(SummaryInformationRow)`
  margin-left: ${spacing2};
  flex: 1 1 0;
`;
